import { IOrganizations } from "../../common/types/groupTypes";

interface NodeWithChildren extends IOrganizations {
    children: NodeWithChildren[];
}

interface IJsonNode {
    orgId: string;
    parent?: string;
    displayName: string;
}

export interface IHierarchyNode {
    value: string;
    label: string;
    children?: IHierarchyNode[];
}

 const convertToHierarchy = (jsonNodes: IJsonNode[], parentId: string | null = null): IHierarchyNode[] => {
    const nodes: IHierarchyNode[] = jsonNodes
        .filter((node) => node.parent === parentId || (!node.parent && !parentId))
        ?.map((node) => ({
            value: node.orgId,
            label: node.displayName,
            children: convertToHierarchy(jsonNodes, node.orgId),
        }));

    return nodes.length ? nodes : [];
};

export const getHierarchy = (jsonNodes: IJsonNode[], parentId: string | null = null): IHierarchyNode[] => {
    const node: IJsonNode = jsonNodes.find(node => node.orgId === parentId);
    const hierarchy: IHierarchyNode[] = [{
        value: node.orgId,
        label: node.displayName,
        children: convertToHierarchy(jsonNodes, node.orgId),
    }]
    return hierarchy;
}

export const buildGroupIdToHierarchyMap = (organizationList: IOrganizations[]): Record<string, string> => {
    const idToNode: Record<string, NodeWithChildren> = {};

    organizationList.forEach(node => {
        idToNode[node.orgId] = { ...node, children: [] };  
    });

    organizationList.forEach(node => {
        if (node.parent) {
            idToNode[node.parent]?.children.push(idToNode[node.orgId]);
        }
    });

    const getHierarchy = (nodeId: string): Record<string, string> => {
        const node = idToNode[nodeId];
        const parents: string[] = [];
        let current: NodeWithChildren | undefined = node;

        while (current) {
            parents.unshift(current.displayName);
            current = idToNode[current.parent || ''];
        }

        const result: Record<string, string> = { [nodeId]: parents.length > 1 ? parents.slice(1).join('/') : parents.join('/') };
        return result;
    };

    const result: Record<string, string>[] = Object.keys(idToNode).map(nodeId => getHierarchy(nodeId));
    return result.reduce((acc, curr) => ({ ...acc, ...curr }), {});
};
